import { BiMatricScores } from "../../../pages";
import adminRouteMap from "../../../routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: `${adminRouteMap.BI_METRIC.path}/:id`,
      name: "BiMatricScores",
      key: `${adminRouteMap.BI_METRIC.path}/:id`,
      commonRoute: false,
      private: true,
      belongsToSidebar: false,
      element: <BiMatricScores />,
    },
  ];
}
